import { createSlice } from '@reduxjs/toolkit';

import { filterTagsByOneTag } from '../../utils/filterTags';

import { REQUEST } from '../../constants/request';
import { generateItemCIDKey } from '../../components/Items/utils/generateItemCIDKey';

import { fetchSearchingStreamItemsExtraReducers } from './asyncThunk/fetchSearchingStreamItems';

export { fetchSearchingStreamItems } from './asyncThunk/fetchSearchingStreamItems';

const INITIAL_STATE = {
  urlParams: {
    orgId: null,
    streamId: null,
    channelId: null,
  },
  tags: [],
  value: '',
  currentLoadings: {},
  currentRequestIds: {},
  currentErrors: {},
  error: null,
  isShownDeleteMessage: false,
  items: {
    byId: {},
    allIds: [],
    request: {},
  },
};

export const SearchSlice = createSlice({
  name: 'search',
  initialState: INITIAL_STATE,
  reducers: {
    addSearchTag: (state, { payload }) => {
      state.tags.push(payload);
    },
    setSearchTags: (state, { payload }) => {
      state.tags = payload;
    },
    addSearchParams: (state, { payload }) => {
      const { orgId, streamId, channelId } = payload;

      state.urlParams.orgId = orgId;
      state.urlParams.streamId = streamId;
      state.urlParams.channelId = channelId;
    },
    clearSearch: state => {
      state.tags = [];
      state.value = '';
    },
    removeSearchTag: (state, { payload }) => {
      const newTagList = filterTagsByOneTag(state.tags, payload);
      state.tags = [...newTagList];
    },
    setSearchPathValue: (state, { payload }) => {
      state.value = payload;
    },
    resetSearchSlice: () => INITIAL_STATE,
  },
  extraReducers: builder => {
    fetchSearchingStreamItemsExtraReducers(builder);
  },
});

export const {
  addSearchTag,
  setSearchTags,
  addSearchParams,
  clearSearch,
  removeSearchTag,
  setSearchPathValue,
  resetSearchSlice,
} = SearchSlice.actions;

export default SearchSlice.reducer;

export const selectorSearchIsFocused = state => state.search.isFocused;
export const selectorSearchTags = state => state.search.tags;
export const selectorSearchValue = state => state.search.value;
export const selectorSearchUrlParams = state => state.search.urlParams;
export const selectorSearchById = (
  state,
  { orgId, streamId, channelId, streamItemId },
) =>
  state.search.items.byId[
    generateItemCIDKey({ orgId, streamId, channelId, streamItemId })
  ];
export const selectorSearchLoadingState = (state, searchUID) =>
  state.search.items.request[searchUID] || REQUEST.idle;
